export const WARNING = 'WARNING'
export const ERROR = 'ERROR'

export const SMALL = 'small'
export const DEFAULT = 'default'
